/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Loading_SetsInputs */



/**
* | output |
* | --- |
* | "Loading sets... please wait..." |
*
* @param {Tags_Manager_Loading_SetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_loading_sets = /** @type {((inputs?: Tags_Manager_Loading_SetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Loading_SetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des ensembles... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sets werden geladen... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dei set... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка наборов... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando conjuntos... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载设置……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セットを読み込んでいます...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेट लोड हो रहे हैं... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando conjuntos... aguarde...")
	return /** @type {LocalizedString} */ ("Loading sets... please wait...")
});